import { render, staticRenderFns } from "./FAQManagement.vue?vue&type=template&id=e0cde138&scoped=true&"
import script from "./FAQManagement.vue?vue&type=script&lang=js&"
export * from "./FAQManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0cde138",
  null
  
)

export default component.exports